export default __webpack_public_path__ + "static/3-9e3ffe8fb5f1cf297cdb1d201809c82f.webp";